<div class="table-container">
  <p-table #dt [value]="usuarios" responsiveLayout="scroll" [paginator]="true" [rows]="10"
    [rowsPerPageOptions]="[10, 25, 50, 100]" [globalFilterFields]="['login', 'status']">

    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="login">Login <p-sortIcon field="login"></p-sortIcon></th>
        <th pSortableColumn="email">E-mail <p-sortIcon field="email"></p-sortIcon></th>
        <th pSortableColumn="status">Status <p-sortIcon field="status"></p-sortIcon></th>
        <th class="acoes-column"></th>
      </tr>
    </ng-template>

    <ng-template #body let-usuario>
      <tr class="table-row">
        <td>{{ usuario.login }}</td>
        <td>{{ usuario.email }}</td>
        <td>{{ getStatusNome(usuario.status) }}</td>
        <td>
          @if (usuario.status === UsuarioStatus.AguardandoAprovacao) {
            <div class="inline-element">
              <button pButton icon="pi pi-check" text rounded severity="success"
                pTooltip="Aprovar cadastro" tooltipPosition="top"
                (click)="aprovarUsuarioClick(usuario)">
              </button>
              <button pButton icon="pi pi-times" text rounded severity="danger"
                pTooltip="Recusar cadastro" tooltipPosition="top"
                (click)="rejeitarUsuarioClick(usuario)">
              </button>
            </div>
          }
          @if (usuario.status === UsuarioStatus.AguardandoTrocaDeSenha) {
            <div class="inline-element">
              <button *hasPermission="Permissao.TROCAR_SENHA_USUARIO" pButton icon="pi pi-key" text rounded severity="info"
                pTooltip="Liberar troca de senha" tooltipPosition="top"
                (click)="trocarSenhaClick(usuario)">
              </button>
            </div>
          }
        </td>
      </tr>
    </ng-template>

  </p-table>
</div>
